<div class="attach-doc">
  <mat-icon class="attach-doc-mark" style="margin-right: 10px">play_circle_outline</mat-icon>
  <div fxLayout="column">
      <span class="file-name" title="">
        <a [href]="file.publicUrl" target="_blank" i18n="Post message item|label @@postMessageItem.voiceLabel">Голосовое сообщение</a>
      </span>
    <span class="size">{{ file.voice.duration | duration }}</span>
  </div>
</div>
